// TODO: Find a better way to accomplish this
import { useAppStore } from '@/stores/app'

export default defineNuxtRouteMiddleware(() => {
  const appStore = useAppStore()

  // By default the back button should not be visible.
  if (appStore.backButton.visible) {
    appStore.setBackButton({
      visible: false,
      text: undefined,
      to: undefined
    })
  }
})
